import { APP_CONFIG } from '../constants/global-variables.js';

export async function getPost(id) {

    try {
        const res = await axios.get(url, {
            headers: {
              "Content-Type": "application/json",
            },
          });
          
        return res;
    } catch (err) {
        //console.log("Error getting documents", err);
    }
}
